/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import queryString from 'querystring'
import env from 'env'

export const getTexts = ({ code, updated }) => ({
  type: 'API/GET_TEXTS',
  payload: {
    apiAction: {
      hostname: env.api,
      url: `/api/localization?${queryString.stringify({ code, updated })}`,
      headers: {},
      method: 'GET',
    },
  },
  meta: {
    noAuth: true,
    mock: true,
  },
})
getTexts.toString = () => 'API/GET_TEXTS'
